import { Box, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { ptBR } from "@mui/x-data-grid/locales";
import { useCustomers, useData } from "./useData";

const renderHeader = function () {
  return (
    <Typography fontWeight={"bold"} fontSize={14}>
      {this.headerName}
    </Typography>
  );
};

const columns = [
  {
    field: "name",
    headerName: "NOME",
    renderHeader,
    width: 320,
  },
  {
    field: "username",
    headerName: "USUÁRIO",
    renderHeader,
    width: 320,
  },
  {
    field: "document",
    headerName: "DOCUMENTO",
    renderHeader,
    width: 180,
  },
  {
    field: "email",
    headerName: "EMAIL",
    renderHeader,
    width: 180,
  },
  {
    field: "date",
    headerName: "DATA DE CADASTRO",
    renderHeader,
    width: 180,
  },
  {
    field: "createdBy",
    headerName: "QUEM CADASTROU",
    renderHeader,
    width: 180,
  },
  {
    field: "updatedAt",
    headerName: "ÚLTIMA ALTERAÇÃO",
    renderHeader,
    width: 180,
  },
  {
    field: "updatedBy",
    headerName: "QUEM FEZ A ÚLTIMA ALTERAÇÃO",
    renderHeader,
    width: 180,
  },
];

export default function ProductionHistory() {
  const { request, onNextPage } = useData();

  const { data, loading, page, limit, currentPage, totalPages, totalItems } =
    request;

  return (
    <Box sx={{ height: 500, flex: 1 }}>
      <DataGrid
        initialState={{
          columns: {
            columnVisibilityModel: {
              // Hide columns status and traderName, the other columns will remain visible
              phone: false,
              email: false,
              updatedAt: false,
              updatedBy: false,
              createdBy: false,
            },
          },
        }}
        disableColumnResize
        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
        loading={loading}
        paginationMode="server"
        rowHeight={36}
        rows={data}
        isRowSelectable={false}
        columns={columns}
        pageSizeOptions={[...new Set([limit, 5, 10, 20, 50, 100])]}
        //autoPageSize
        rowCount={totalItems || 0}
        paginationModel={{ page, pageSize: limit }}
        onPaginationModelChange={onNextPage}
        rowsPerPageOptions={[...new Set([limit, 5, 10, 20, 50, 100])]}
        disableSelectionOnClick
        pagination
      />
    </Box>
  );
}
